export const FORM_NAME_REQUEST = 'forgotPassword'
export const FORM_NAME_RESET = 'resetPassword'
